/**
 * Vérifie la validité des données de tarification dégressive selon la relation client
 * @param volumePricingTableJson - JSON contenant le tableau de prix dégressifs
 * @param customerHierarchyCode - Code de la hiérarchie client (BusinessPartnerId)
 * @param priceGroup - Groupe de prix du client
 * @returns true si des données valides sont trouvées, false sinon
 */
export const checkVolumePricingValidity = (
    volumePricingTableJson: string | undefined,
    customerHierarchyCode: string | undefined,
    priceGroup: string | undefined
): boolean => {
    if (!volumePricingTableJson) {
        return false;
    }

    let pricingRows: any[] = [];
    try {
        pricingRows = JSON.parse(volumePricingTableJson);
    } catch {
        return false;
    }

    if (!Array.isArray(pricingRows) || pricingRows.length === 0) {
        return false;
    }

    // 1. Chercher AT="C" & AR=customerHierarchyCode
    let filteredRows = pricingRows.filter(row => row.AT === 'C' && row.AR === customerHierarchyCode);

    // 2. Sinon AT="G" & AR=priceGroup
    if (filteredRows.length === 0 && priceGroup) {
        filteredRows = pricingRows.filter(row => row.AT === 'G' && row.AR === priceGroup);
    }

    // 3. Sinon AT="A"
    if (filteredRows.length === 0) {
        filteredRows = pricingRows.filter(row => row.AT === 'A');
    }

    return filteredRows.length > 0;
};
